// NameModal.jsx
import React, { useState, useEffect } from 'react';

const NameModal = ({ onClose, onSubmitName }) => {
  const [nameInput, setNameInput] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animate in after component mounts
    setIsVisible(true);
  }, []);

  const handleSubmit = () => {
    if (nameInput.trim()) {
      onSubmitName(nameInput.trim());
    }
    // Always close after submission attempt, even if empty, as per requirement
    // to not bother the user again if they've interacted.
    onClose(); 
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission if it's within a form
      handleSubmit();
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-end justify-center pointer-events-none transition-all duration-500 ease-out
        ${isVisible ? 'opacity-100' : 'opacity-0'}
      `}
    >
      <div
        className={`bg-gray-800 p-6 rounded-t-xl shadow-lg w-full max-w-md mx-auto relative pointer-events-auto
          transform transition-transform duration-500 ease-out
          ${isVisible ? 'translate-y-0' : 'translate-y-full'}
        `}
      >
        <button
          onClick={onClose} // This will also set nameModalDismissed in HomePage
          className="absolute top-3 right-3 text-gray-400 hover:text-white text-xl focus:outline-none"
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-xl font-bold mb-4 text-white">What's your name?</h2>
        <p className="text-gray-300 mb-4">Let's get to know each other better!</p>
        <input
          type="text"
          value={nameInput}
          onChange={(e) => setNameInput(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
          placeholder="Enter your name"
          aria-label="Your Name"
          autoFocus // Automatically focus the input field
        />
        <button
          onClick={handleSubmit}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default NameModal;